const CDN_PATH_PREFIX = "./";

export class AssetManager {
  constructor(private readonly cdnBaseUrl: string) {}

  getUrl(path: string) {
    if (!path.startsWith(CDN_PATH_PREFIX)) {
      return path;
    }

    return this.cdnBaseUrl + path.substr(CDN_PATH_PREFIX.length);
  }
}
